import React from 'react';
import ChangeNameModal from './modals/ChangeNameModal';
import { withRouter } from 'react-router';
import IPModifyModal from './modals/IPModifyModal';
import UsernameModifyModal from './modals/UsernameModifyModal';
import DomainModifyModal from './modals/DomainModifyModal';
import ChangeHostingOS from './modals/ChangeHostingOS';

const mouse_cursor_style = {color:"#42A5F5", cursor: 'pointer'};

function ModifyHostingOSBtn(userProduct, onShowHostOSModifyModal) {
  const product_type =  userProduct.product.product_type;
  const modify_label = product_type == "LINUX_HOSTING" ? "Chuyển sang Windows" : "Chuyển sang Linux";
  let inner_modify_btn = null;
  if(["LINUX_HOSTING", "WINDOW_HOSTING"].includes(product_type)) {
    inner_modify_btn = <React.Fragment>
      <span className="text-muted">{product_type} </span> 
      <span onClick={()=> onShowHostOSModifyModal()} style={mouse_cursor_style}> 
        [ {modify_label} ] 
      </span>
    </React.Fragment>
  }
  return inner_modify_btn;
}

// Nút thay đổi Domain Chon các dịch vụ.
// Ví dụ: SSL, Hosting, Email.
function ModifyDomainBtn(userProduct, onShowDomainModifyModal) {
  const product_type =  userProduct.product.product_type;
  let inner_domain_modify_btn = null;
  if(["SSL","EMAIL" , "LINUX_HOSTING", "WINDOW_HOSTING"].includes(product_type)) {
    inner_domain_modify_btn = <span onClick={()=> onShowDomainModifyModal()} style={mouse_cursor_style}> [sửa] </span>
  }
  return inner_domain_modify_btn;
}

// Hiển thị tên dịch vụ của khách hàng.
function ProductNameLabel(userProduct) { 
  const product_type =  userProduct.product.product_type;
  let product_name = null;
  if(["VPS", "CLOUD_SERVER_PRO", "DIGITAL_SIGNATURE", "TADU_INVOICE", "CLOUD_BACKUP"].includes(product_type)) {
    product_name = userProduct.name ? userProduct.name : "Khách hàng chưa đặt tên";
  }
  return product_name;
}

// Hiển thị thông tin Domain cho dịch vụ.
function DomainLabel(userProduct, onShowDomainModifyModal) {
  const product_type =  userProduct.product.product_type;
  let domain_label = null;
  if(["COM_DOMAIN", "VN_DOMAIN", "TADU_PHONE", "SSL","EMAIL" , "LINUX_HOSTING", "WINDOW_HOSTING"].includes(product_type)) {
    domain_label = userProduct.domain;
  }

  if(["VPS", "CLOUD_SERVER_PRO", "CLOUD_BACKUP"].includes(product_type)) {
    domain_label = <span className="display-block text-muted">{userProduct.domain}</span>
  }
  return <span>{domain_label} {ModifyDomainBtn(userProduct, onShowDomainModifyModal)}</span> ;
}

// Hiển thị Username cho dịch vụ.
function UsernameLabel(userProduct, onShowUsernameModifyModal) {
  const product_type =  userProduct.product.product_type;
  let username_label = null;
  if(["LINUX_HOSTING", "WINDOW_HOSTING", "CLOUD_BACKUP"].includes(product_type)) {
    username_label = <span className="display-block text-muted">username: 
      {" " + userProduct.username} <span onClick={()=> onShowUsernameModifyModal()} style={mouse_cursor_style}> [sửa] </span>
    </span>
  }
  return username_label;
}

// Hiển thị IP address cho dịch vụ.
function IpAddressLabel(userProduct, onShowIPModifyModal) {
  const product_type =  userProduct.product.product_type;
  let ip_address_label = null;
  if(["VPS", "CLOUD_SERVER_PRO"].includes(product_type)) {
    ip_address_label = <span className="display-block text-muted">
      {userProduct.ip_address} <span onClick={()=> onShowIPModifyModal()} style={mouse_cursor_style}> [sửa] </span>
    </span>
  }
  return ip_address_label;
}

class ProductName extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      is_show_ip_modify_modal: false, // Chỉnh sửa IP dịch vụ
      is_show_domain_modify_modal: false,
      is_show_username_modify_modal: false,
      is_show_host_os_modify_modal: false
    }
  }
  
  // Hiện modal chỉnh sửa DOMAIN Name.
  onShowDomainModifyModal = () => {
    this.setState({
      is_show_domain_modify_modal: true
    })
  }

  // Hiện modal chỉnh sửa IP dịch vụ
  onShowIPModifyModal = () => {
    this.setState({
      is_show_ip_modify_modal: true
    })
  }
  
  // Hiện modal chỉnh sửa username dịch vụ.
  onShowUsernameModifyModal = () => { 
    this.setState({
      is_show_username_modify_modal: true
    })
  }

  // Hiện modal thay đổi  hệ điều hành cho hosting.
  onShowHostOSModifyModal = () => { 
    this.setState({
      is_show_host_os_modify_modal: true
    })
  }

  // Ẩn modal.
  handleHideModal = () => {
    const { tableQuery } = this.props;
    // Reload lại đúng các dữ liệu query sau khi hoàn tất thay đổi tên
    this.setState({
      is_show_ip_modify_modal: false,
      is_show_username_modify_modal: false,
      is_show_domain_modify_modal: false,
      is_show_host_os_modify_modal: false
    })
    this.props.reload(tableQuery)
  }

  render() {
    const {userProduct} = this.props;
    const {is_show_ip_modify_modal, is_show_username_modify_modal, is_show_domain_modify_modal, is_show_host_os_modify_modal} = this.state;
    return(
      <React.Fragment>
        {ProductNameLabel(userProduct)}
        {DomainLabel(userProduct, this.onShowDomainModifyModal)}
        {UsernameLabel(userProduct, this.onShowUsernameModifyModal)}
        {IpAddressLabel(userProduct, this.onShowIPModifyModal)}
        <span className="display-block text-muted">{userProduct.product.name}</span>
        {ModifyHostingOSBtn(userProduct, this.onShowHostOSModifyModal)}
        {is_show_ip_modify_modal && <IPModifyModal title="Chỉnh Sửa IP" show={is_show_ip_modify_modal} onHide={this.handleHideModal} ipProduct={userProduct} ipType={"SERVICE"} />}
        {is_show_username_modify_modal && <UsernameModifyModal title="Chỉnh Sửa Username dịch vụ" show={is_show_username_modify_modal} onHide={this.handleHideModal} userProduct={userProduct} />}
        {is_show_domain_modify_modal && <DomainModifyModal title="Chỉnh Sửa Domain dịch vụ" show={is_show_domain_modify_modal} onHide={this.handleHideModal} userProduct={userProduct} />}
        {is_show_host_os_modify_modal && <ChangeHostingOS title="Thay đổi cấu hình Hosting" show={is_show_host_os_modify_modal} onHide={this.handleHideModal} userProduct={userProduct} />}
      </React.Fragment>
    )
  }

}

export default withRouter(ProductName);